import React from 'react';
import BaseLayout from '../../components/layout/BaseLayout';
import styles from './PrivacyPage.module.css';
import { FaTerminal } from 'react-icons/fa';
import { useTranslation } from '../../hooks/useTranslation';

const PrivacyPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <BaseLayout>
            <div className={styles.container}>
                <header className={styles.header}>
                    <div className={styles.headerContent}>
                        <FaTerminal size={54} className={styles.terminalIcon} />
                        <div className={styles.headerText}>
                            <h1 className={styles.title}>{t("privacy.title")}</h1>
                            <p className={styles.subtitle}>
                                {t("privacy.subtitle")}
                            </p>
                        </div>
                    </div>
                </header>

                <div className={styles.content}>
                    <div className={styles.paragraph}>
                        <h2>{t("privacy.lastUpdated")}</h2>
                        <p>
                            {t("privacy.intro")}
                        </p>
                        <p>
                            {t("privacy.changes")}
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("privacy.howWeUse.title")}</h2>
                        <p>{t("privacy.howWeUse.intro")}</p>
                        <ul>
                            <li>{t("privacy.howWeUse.list.1")}</li>
                            <li>{t("privacy.howWeUse.list.2")}</li>
                            <li>{t("privacy.howWeUse.list.3")}</li>
                        </ul>
                        <p>
                            {t("privacy.howWeUse.permission")}
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("privacy.howWeShare.title")}</h2>
                        <p>
                            {t("privacy.howWeShare.intro")}
                        </p>
                        <ul>
                            <li>{t("privacy.howWeShare.list.1")}</li>
                        </ul>
                        <p>
                            {t("privacy.howWeShare.thirdParties")}
                        </p>
                        <p>
                            {t("privacy.howWeShare.disclosure")}
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("privacy.rights.title")}</h2>
                        <p>
                            {t("privacy.rights.access")}
                        </p>
                        <p>
                            {t("privacy.rights.notice")}
                        </p>
                        <p>
                            {t("privacy.rights.cookies")} <a href="/cookies" className={styles.link}>{t("cookies.title")}</a>.
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("privacy.security.title")}</h2>
                        <p>
                            {t("privacy.security.measures")}
                        </p>
                        <p>
                            {t("privacy.thirdParty.title")}
                        </p>
                        <p>
                            {t("privacy.thirdParty.content")}
                        </p>
                        <p>
                            {t("privacy.questions.title")}
                        </p>
                        <p>
                            {t("privacy.questions.contact")}
                        </p>
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};

export default PrivacyPage; 